// ELECTRICITY PURCHASED
export const API_GET_ELECTRICITY_PURCHASED_PER_GROUP = 'api/cf/get-electricity-purchased-per-group';
export const API_GET_ELECTRICITY_PURCHASED_PER_FACILITY = 'api/cf/get-electricity-purchased-per-facility';
// RENEWABLE ENERGY
export const API_GET_RENEWABLE_ENERGY_PER_GROUP = 'api/cf/get-renewable-energy-per-group'
export const API_GET_RENEWABLE_ENERGY_PER_FACILITY = 'api/cf/get-renewable-energy-per-facility'
// FUEL COMBUSTED
export const API_GET_FUEL_COMBUSTED_PER_GROUP = 'api/cf/get-fuel-combusted-per-group';
export const API_GET_FUEL_COMBUSTED_PER_FACILITY = 'api/cf/get-fuel-combusted-per-facility';
// LPG
export const API_GET_LPG_COMBUSTED_PER_GROUP = 'api/cf/get-lpg-combusted-per-group';
export const API_GET_LPG_COMBUSTED_PER_FACILITY = 'api/cf/get-lpg-combusted-per-facility';
// REFRIGERANT GAS TOP UPS
export const API_GET_REFRIGERANT_GAS_TOP_UP_PER_GROUP = 'api/cf/get-refrigerant-top-ups-per-group';
export const API_GET_REFRIGERANT_GAS_TOP_UP_PER_FACILITY = 'api/cf/get-refrigerant-top-ups-per-facility';
// DRY ICE
export const API_GET_DRY_ICE_PURCHASED_PER_GROUP = 'api/cf/get-dry-ice-purchased-per-group';
export const API_GET_DRY_ICE_PURCHASED_PER_FACILITY = 'api/cf/get-dry-ice-purchased-per-facility';
// WASTE GENERATED
export const API_GET_WASTE_GENERATED_PER_GROUP = 'api/cf/get-waste-generated-per-group';
export const API_GET_WASTE_GENERATED_PER_FACILITY = 'api/cf/get-waste-generated-per-facility';
// FLIGHTS AND ACCOMMODATION
export const API_GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP = 'api/cf/get-flights-and-accommodation-per-group';
export const API_GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY = 'api/cf/get-flights-and-accommodation-per-facility';
// CAR HIRE
export const API_GET_CAR_HIRE_PER_GROUP = 'api/cf/get-car-hire-per-group';
export const API_GET_CAR_HIRE_PER_FACILITY = 'api/cf/get-car-hire-per-facility';
// PETROL CARDS
export const API_GET_PETROL_CARDS_PER_GROUP = 'api/cf/get-petrol-cards-per-group';
export const API_GET_PETROL_CARDS_PER_FACILITY = 'api/cf/get-petrol-cards-per-facility';
// DOWNSTREAM DISTRIBUTION
export const API_GET_DOWNSTREAM_DISTRIBUTION_PER_GROUP = 'api/cf/get-downstream-distribution-per-group';
export const API_GET_DOWNSTREAM_DISTRIBUTION_PER_FACILITY = 'api/cf/get-downstream-distribution-per-facility';
// WATER
export const API_GET_WATER_PER_GROUP = 'api/cf/get-water-per-group';
export const API_GET_WATER_PER_FACILITY = 'api/cf/get-water-per-facility';
// CHEMICALS AND ADDITIVES
export const API_GET_CHEMICALS_AND_ADDITIVES_PER_GROUP = 'api/cf/get-chemicals-and-additives-per-group'
export const API_GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY = 'api/cf/get-chemicals-and-additives-per-facility'
// WOODEN PRODUCTS
export const API_GET_WOODEN_PRODUCTS_PER_GROUP = 'api/cf/get-wooden-products-per-group'
export const API_GET_WOODEN_PRODUCTS_PER_FACILITY = 'api/cf/get-wooden-products-per-facility'
// PACKAGING
export const API_GET_PACKAGING_PER_GROUP = 'api/cf/get-packaging-per-group'
export const API_GET_PACKAGING_PER_FACILITY = 'api/cf/get-packaging-per-facility'
// WINE AND GRAPES
export const API_GET_WINE_AND_GRAPES_PER_GROUP = 'api/cf/get-wine-and-grapes-per-group'
export const API_GET_WINE_AND_GRAPES_PER_FACILITY = 'api/cf/get-wine-and-grapes-per-facility'
// OTHER
export const API_GET_OTHER_PER_GROUP = 'api/cf/get-other-per-group'
export const API_GET_OTHER_PER_FACILITY = 'api/cf/get-other-per-facility'
// FERTILIZERS
export const API_GET_FERTILIZERS_PER_GROUP = 'api/cf/get-fertilizers-per-group'
export const API_GET_FERTILIZERS_PER_FACILITY = 'api/cf/get-fertilizers-per-facility'
// AGROCHEMICALS
export const API_GET_AGROCHEMICALS_PER_GROUP = 'api/cf/get-agrochemicals-per-group'
export const API_GET_AGROCHEMICALS_PER_FACILITY = 'api/cf/get-agrochemicals-per-facility'
// CAPITAL GOODS AND SERVICES
export const API_GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP = 'api/cf/get-capital-goods-and-services-per-group'
export const API_GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY = 'api/cf/get-capital-goods-and-services-per-facility'

export const API_EXPORT_COMPANY_CONSUMPTION_SUMMARY = 'api/cf/export-company-consumption-summary'
export const API_EXPORT_GROUP_CONSUMPTION_SUMMARY = 'api/cf/export-group-consumption-summary'
